import axios from 'axios'
import { CONFIG } from '../config/Config'
import { refreshTokenInterceptor } from './interceptors'

const DEFAULT_REQUEST_TIMEOUT = 50000
const AUTH_SCHEME = 'BEARER'

export const api = axios.create({
  baseURL: CONFIG.API_BASE_PATH,
  timeout: CONFIG.API_TIMEOUT || DEFAULT_REQUEST_TIMEOUT,
  withCredentials: true,
})

api.interceptors.response.use((response) => response, refreshTokenInterceptor(AUTH_SCHEME))
